export const LocalStorageKeys = {
  token: 'token',
  user: 'user',
  settings: 'settings',
  totalSchoolDay: 'totalSchoolDay',
  studentAttendance: 'studentAttendance',
  studentSession: 'studentSession',
  currentSchoolId: 'current_school_id',
  schoolType: 'school_type',
  sessionId: 'session_id',
  authToken: 'authToken',
  schoolId: 'schoolId',
  subjectsData: 'subjectsData',
  selectedTerm: 'selectedTerm',
  selectedClassroom: 'selectedClassroom',
  teacherRemark: 'teacherRemark',
  principalRemark: 'principalRemark',
};
